import {
    get2,
    post,
    url,
    fetch,
    fetch2,
    put2
} from "../http"
class curriculum {
    //课程
    @url("open/jm/listCourseJmV2")
    @get2
    getCourselist() {}
    //课程详情
    @url("/course/teach/course/courseInfo/")
    @fetch2
    findCourse() {}
    //课程详情时间类型
    @url("/course/teach/course/courseStudyInfo/")
    @fetch2
    getCourseStudyInfo() {}
    //课程详情时间类型2
    @url("/course/teach/course/courseStudyInfo2")
    @get2
    getCourseStudyInfo2() {}
    //课程内容列表
    @url("/course/teach/lesson/getLessonForRecommend/")
    @fetch2
    getLessonNewList() {}
    //获取异步课的视频地址
    @url("/course/teach/lesson/getLessonVideoUrl/")
    @fetch2
    getLessonVideoUrl() {}
    // 异步课统计上课时长 本次观看时间戳
    @url("/course/teach/lessonCount/startWatch")
    @put2
    watchStamp() {}
    // 异步课统计用户上课时间
    @url("/course/teach/lessonCount/updateCourseCountAsyn")
    @put2
    countTime() {}
    //获取异步课视频课节信息
    @url("/course/teach/lesson/getLessonById/")
    @fetch2
    getAsnycLive() {}
    //课程详情 -- 课程详情
    @url("/course/teach/course/courseInfo/")
    @fetch2
    getCourseInfo() {}

}
export default new curriculum()